import { render, staticRenderFns } from "./valuable-concepts-modal-skeletons-table.vue?vue&type=template&id=72faca4c&"
import script from "./valuable-concepts-modal-skeletons-table.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-skeletons-table.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports